import { render, staticRenderFns } from "./SIPPDB.vue?vue&type=template&id=67e90d45&"
import script from "./SIPPDB.vue?vue&type=script&lang=js&"
export * from "./SIPPDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports